/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";

type BankDataContainerProps = {
  divorce: AbstractCase;
  process: boolean;
  hearing: boolean;
  installmentRate?: string | null;
};

const BankDataContainer = ({ divorce, process, hearing, installmentRate = null }: BankDataContainerProps) => {
  const bankdata = divorce.lawFirm.bankdata;
  const processCosts = divorce.processFeeAndExpenses;

  return (
    <Grid container sx={{ padding: "25px 0" }}>
      <Grid size={12}>
        {process && !installmentRate && (
          <Box>
            <strong>
              Bitte überweisen Sie {processCosts.toLocaleString("de-DE", {style: "currency", currency: "EUR",})} für die Verfahrensgebühr an
            </strong>
            <br />
            Empfänger: {divorce && divorce.lawFirm.name}
            <br />
            Bank: {bankdata && bankdata.bankName}
            <br />
            IBAN: {bankdata && bankdata.iban}
            <br />
            Verwendungszweck: Verfahrensgebühr {divorce && divorce.reference}-R1
            <br />
            <br />
          </Box>
        )}
        {hearing && !installmentRate && (
          <Box>
            <strong>
              Bitte überweisen Sie {divorce.hearingFee && divorce.hearingFee.toLocaleString("de-DE", {style: "currency", currency: "EUR",})} für die Terminsgebühr an
            </strong>
            <br />
            Empfänger: {divorce && divorce.lawFirm.name}
            <br />
            Bank: {bankdata && bankdata.bankName}
            <br />
            IBAN: {bankdata && bankdata.iban}
            <br />
            Verwendungszweck: Terminsgebühr {divorce && divorce.reference}-R2 <br />
          </Box>
        )}
        {installmentRate && (
          <Box>
            <strong>Bitte überweisen Sie die Rate von {installmentRate} € immer spätestens bis zum 5. des Monats an</strong>
            <br />
            <br />
            Empfänger: {divorce && divorce.lawFirm.name}
            <br />
            Bank: {bankdata && bankdata.bankName}
            <br />
            IBAN: {bankdata && bankdata.iban}
            <br />
            Verwendungszweck: Ratenzahlung {divorce && divorce.reference} <br />
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default BankDataContainer;
